import { PriceStatusClass } from "../../../../data";
export const statusModifier = {
    0: PriceStatusClass.periodPre,
    1: PriceStatusClass.periodCurrent,
    2: PriceStatusClass.periodResulting,
    3: PriceStatusClass.periodOver
};
//# sourceMappingURL=statusModifier.js.map